import React, { useState, useEffect } from 'react';
import './EquipmentModal.css';

const ISOLEMENT_OPTIONS = ["1", "10", "M", "B", "<0,5", ">0,5", "100"];

export default function LuminaireModal({ isOpen, onClose, onSave, local, equipment }) {
  const [formData, setFormData] = useState({
    category: 'luminaire',
    code: '',
    name: 'Luminaire',
    existing_quantity: 1,
    verified_quantity: 1,
    protection_type: '',
    continuity_result: '',
    isolement: '',
    result: 'conforme'
  });

  useEffect(() => {
    if (equipment) {
      setFormData(equipment);
    }
  }, [equipment]);

  const handleCodeChange = (code) => {
    let updates = { code };
    
    switch(code) {
      case 'AE1':
        updates.name = "Appareil d'éclairage classe 1";
        updates.continuity_result = 'Bon';
        break;
      case 'AE2':
        updates.name = "Appareil d'éclairage classe 2";
        updates.continuity_result = 'Classe II';
        break;
      case 'AE3':
        updates.name = "Appareil d'éclairage classe 3";
        updates.continuity_result = 'Classe III';
        break;
    }
    
    setFormData(prev => ({ ...prev, ...updates }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.continuity_result) {
      alert('Veuillez sélectionner la continuité PE');
      return;
    }
    onSave({
      type: 'luminaire',
      ...formData
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="equipment-modal-overlay" onClick={onClose}>
      <div className="equipment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="equipment-modal-header">
          <div>
            <h2 className="equipment-modal-title">💡 Luminaire</h2>
            <p className="equipment-modal-subtitle">{local?.nom}</p>
          </div>
          <button onClick={onClose} className="equipment-close-button">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="equipment-form">
          <div className="equipment-form-scroll">
            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Code <span className="equipment-required">*</span>
              </label>
              <select
                value={formData.code}
                onChange={(e) => handleCodeChange(e.target.value)}
                className="equipment-form-select"
                required
              >
                <option value="">- Sélectionner -</option>
                <option value="AE1">AE1 - Appareil d'éclairage classe 1</option>
                <option value="AE2">AE2 - Appareil d'éclairage classe 2</option>
                <option value="AE3">AE3 - Appareil d'éclairage classe 3</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Nom de l'équipement</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="equipment-form-input"
                placeholder="Ex: Luminaire plafond"
              />
            </div>

            <div className="equipment-form-row">
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité existante</label>
                <input
                  type="number"
                  min="0"
                  value={formData.existing_quantity}
                  onChange={(e) => setFormData({...formData, existing_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité vérifiée</label>
                <input
                  type="number"
                  min="0"
                  value={formData.verified_quantity}
                  onChange={(e) => setFormData({...formData, verified_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Type de protection</label>
              <input
                type="text"
                value={formData.protection_type}
                onChange={(e) => setFormData({...formData, protection_type: e.target.value})}
                className="equipment-form-input"
                placeholder="Ex: IP20, IP44, etc."
              />
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Continuité PE <span className="equipment-required">*</span>
              </label>
              <select
                value={formData.continuity_result}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  continuity_result: e.target.value,
                  isolement: e.target.value === 'Mauvais' ? '>0,5' : prev.isolement
                }))}
                className="equipment-form-select"
                required
              >
                <option value="">- Sélectionner -</option>
                <option value="Bon">Bon</option>
                <option value="Mauvais">Mauvais</option>
                <option value="Classe II">Classe II</option>
                <option value="Classe III">Classe III</option>
                <option value="NVE">NVE</option>
                <option value="NVI">NVI</option>
                <option value="NVX">NVX</option>
                <option value="NV">NV</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Isolement (MΩ)</label>
              <input
                type="text"
                list="isolement-options-luminaire"
                value={formData.isolement || ''}
                onChange={(e) => setFormData({...formData, isolement: e.target.value})}
                className="equipment-form-input"
                placeholder="Ex: >0,5, 1, 10, 100, M, B..."
              />
              <datalist id="isolement-options-luminaire">
                {ISOLEMENT_OPTIONS.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>
          </div>

          <div className="equipment-form-buttons">
            <button type="button" onClick={onClose} className="equipment-cancel-button">
              ← Retour
            </button>
            <button type="submit" className="equipment-save-button">
              {equipment ? 'Mettre à jour' : '+ Ajouter rapidement'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}